import React from 'react';
import { Radio } from 'antd';
import styles from '../../Style/LayerOverview.module.scss'
import {overlay, surfaceMapCategory} from "../../../../../types/marker";

interface SurfaceMapRadioGroupProps {
  categories: surfaceMapCategory[];
  overlays: overlay[];
  selectedValue: string;
  onChange: (value: string) => void;
}

const SurfaceMapRadioGroup: React.FC<SurfaceMapRadioGroupProps> = ({
   categories,
   overlays,
   selectedValue,
   onChange
 }) => {
  return (
    <Radio.Group
      className={`${styles.radioGroup}`}
      onChange={(e) => onChange(e.target.value)}
      value={selectedValue}
    >
      <div className={styles.radioItemNone}>
        <div className={styles.label}>None</div>
        <Radio className={styles.radioItem} value="none" />
      </div>

      {categories.map((category) => (
        <div key={category.name}>
          <div className={`${styles.level1}`}>{category.name}</div>
          {overlays
            .filter((o) => o.Level1 === category.name)
            .map((item) => (
              <div key={item.Level2} className={styles.radioItemWrapper}>
                <div className={styles.label}>{item.Level2}</div>
                <Radio
                  className={styles.radioItem}
                  value={`${item.Level1}|${item.Level2}`}
                />
              </div>
            ))}
        </div>
      ))}
    </Radio.Group>
  );
};

export default SurfaceMapRadioGroup;
